import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.define-property";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Cascader from './cascaderInner.vue';
import { isUndef } from '@/lib/utils';

var CustomCascader =
/** @class */
function (_super) {
  __extends(CustomCascader, _super);

  function CustomCascader() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.maxLevel = 3;
    _this.visible = false;
    _this.ids = [];
    _this.itemMap = {};
    _this.listMap = {};
    return _this;
  }

  Object.defineProperty(CustomCascader.prototype, "name", {
    get: function get() {
      var _this = this;

      if (!this.itemMap) {
        return '';
      }

      return (this.value || []).map(function (id) {
        return _this.itemMap[id] ? _this.itemMap[id].name : '';
      }).join('');
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CustomCascader.prototype, "lastId", {
    /**
     * 如果没有的情况下，返回null
     *
     * @return {Number|null} 最后一级districtId，当没有districtIds时候返回null
     */
    get: function get() {
      var len = this.ids.length;

      if (len === 0) {
        return null;
      }

      return this.ids[len - 1];
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(CustomCascader.prototype, "moreColumnVisible", {
    /**
     * 指示下一列是否存在
     *
     * 1. 当前列数>=3的情况 -> false
     * 2. isUndef(lastDistrictId) -> true
     * 3. district的level达到标准的情况下 -> false
     * 4. !list == null && !(list.length === 0)
     */
    get: function get() {
      // 如果列数已经到达了3
      if (this.ids.length >= this.maxLevel) {
        return false;
      } // 如果最后一个districtId不存在情况下，表明当前没有任何级别被选中


      var lastId = this.lastId; // 如果最后一级的list不存在，那么返回false

      if (isUndef(this.listMap[lastId]) || !this.listMap[lastId].length) {
        return false;
      }

      if (isUndef(lastId)) {
        return true;
      }

      return true;
    },
    enumerable: false,
    configurable: true
  });

  CustomCascader.prototype.onUpdateIds = function () {
    this.$emit('input', this.ids);
  };

  CustomCascader.prototype.onItemMapUpate = function (itemMap) {
    this.itemMap = itemMap;
  };

  CustomCascader.prototype.onListMapUpate = function (listMap) {
    this.listMap = listMap;
  };

  CustomCascader.prototype.onClickPlaceholder = function () {
    if (this.disabled) {
      return;
    }

    this.visible = true;
  };

  CustomCascader.prototype.onFinish = function () {
    this.visible = false;
  };

  CustomCascader.prototype.innerFetchList = function (item) {
    return __awaiter(this, void 0, void 0, function () {
      var ret, i, len;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.fetchList(item)];

          case 1:
            ret = _a.sent();

            for (i = 0, len = ret.length; i < len; i++) {
              this.$set(this.itemMap, ret[i].id, ret[i]);
            }

            return [2
            /*return*/
            , ret];
        }
      });
    });
  };

  CustomCascader.prototype.created = function () {
    this.innerFetchList({
      id: 0,
      name: ''
    });

    if (this.value && this.value.length) {
      for (var i = 0, len = this.value.length; i < len; i++) {
        this.innerFetchList({
          id: this.value[i],
          name: ''
        });
      }
    }
  };

  __decorate([Prop({
    type: String
  })], CustomCascader.prototype, "title", void 0);

  __decorate([Prop({
    type: Boolean
  })], CustomCascader.prototype, "required", void 0);

  __decorate([Prop({
    type: Array,
    "default": function _default() {
      return [];
    }
  })], CustomCascader.prototype, "value", void 0);

  __decorate([Prop({
    type: String,
    "default": '请选择'
  })], CustomCascader.prototype, "placeholder", void 0);

  __decorate([Prop({
    required: true,
    type: Function
  })], CustomCascader.prototype, "fetchList", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": true
  })], CustomCascader.prototype, "isValidate", void 0);

  __decorate([Prop()], CustomCascader.prototype, "clazz", void 0);

  __decorate([Prop({
    type: String,
    "default": 'right'
  })], CustomCascader.prototype, "textAlign", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], CustomCascader.prototype, "rightArrow", void 0);

  __decorate([Prop({
    type: Boolean,
    "default": false
  })], CustomCascader.prototype, "disabled", void 0);

  __decorate([Prop({
    type: String
  })], CustomCascader.prototype, "color", void 0);

  __decorate([Watch('ids')], CustomCascader.prototype, "onUpdateIds", null);

  CustomCascader = __decorate([Component({
    name: 'CustomCascader',
    components: {
      Cascader: Cascader
    }
  })], CustomCascader);
  return CustomCascader;
}(Vue);

export default CustomCascader;